// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Currency from "../../../../../../library/data-source/country-currency/Currency.bs.js";
import * as Belt_Array from "../../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as CountryConfig from "../../../../../../library/data-source/country-config/app/entity/CountryConfig.bs.js";
import * as CountryContext from "../../../../../../library/data-source/country-config/context/CountryContext.bs.js";
import * as PlaceOrderAssetsManager from "../../assets/PlaceOrderAssetsManager.bs.js";

var vehicleImg = PlaceOrderAssetsManager.getImage("vehicle.svg");

function UnRestrictedVehicleCardCmp(Props) {
  var displayName = Props.displayName;
  var vehicleImgs = Props.vehicleImgs;
  var fare = Props.fare;
  var nearbyVehiclesCount = Props.nearbyVehiclesCount;
  var etaMins = Props.etaMins;
  var vehicleCapacityDetails = Props.vehicleCapacityDetails;
  var isSelected = Props.isSelected;
  var onSelectVehicle = Props.onSelectVehicle;
  var match = CountryContext.useContext(undefined);
  var currencySymbol = CountryConfig.getSymbol(match.country);
  return React.createElement("div", {
              className: "vehicle-card__container " + (
                isSelected ? "selected" : ""
              ),
              onClick: (function (param) {
                  return Curry._1(onSelectVehicle, undefined);
                })
            }, React.createElement("div", {
                  className: "sub-section"
                }, React.createElement("div", {
                      className: "title"
                    }, displayName)), React.createElement("div", {
                  className: "sub-section"
                }, React.createElement("img", {
                      className: "vehicle_img",
                      alt: "Vehicle",
                      src: isSelected ? vehicleImgs.selected : vehicleImgs.deselected
                    }), React.createElement("div", {
                      className: "title"
                    }, Currency.toCurrencyString(fare, currencySymbol))), React.createElement("div", {
                  className: "sub-section"
                }, React.createElement("div", {
                      className: "label"
                    }, String(nearbyVehiclesCount) + " vehicles nearby"), React.createElement("div", {
                      className: "label"
                    }, "ETA: " + String(etaMins) + " mins")), React.createElement("div", {
                  className: "sub-section capacity-details"
                }, Belt_Array.map(vehicleCapacityDetails, (function (capacityDetails) {
                        return React.createElement("div", {
                                    key: capacityDetails.key,
                                    className: "label"
                                  }, capacityDetails.value);
                      }))));
}

var make = UnRestrictedVehicleCardCmp;

export {
  vehicleImg ,
  make ,
  
}
/* vehicleImg Not a pure module */
